import { action, toJS } from "mobx";
import { copyWithJSON } from "./objects.utils";
import { isNil } from "./ramdaEquivalents.utils";
import { isArray, isNumber, isObject } from "./typeChecks.utils";
export var enforceStringIdOnSnapshot = action(function (object) {
    if (isNil(object))
        return object;
    var o = copyWithJSON(object);
    try {
        Object.keys(o).forEach(function (k) {
            var _a, _b;
            if (!o[k])
                return;
            if ((k === 'id' || k.match(/Id$/)) && isNumber(o[k]))
                Reflect.set(o, k, o[k] + '');
            else if (k.match(/Ids$/))
                Reflect.set(o, k, (_a = o[k]) === null || _a === void 0 ? void 0 : _a.map(function (id) { return isNumber(id) ? id + '' : id; }));
            else if (isArray(o[k]))
                Reflect.set(o, k, (_b = o[k]) === null || _b === void 0 ? void 0 : _b.map(enforceStringIdOnSnapshot));
            else if (isObject(o[k]))
                Reflect.set(o, k, enforceStringIdOnSnapshot(o[k]));
        });
        return o;
    }
    catch (e) {
        console.error(e);
        return object;
    }
});
export var getSnapshot = function (obj) {
    var _a, _b, _c;
    if (!obj)
        return obj;
    var snapshot = (_b = (_a = obj.$getSnapshot) === null || _a === void 0 ? void 0 : _a.call(obj)) !== null && _b !== void 0 ? _b : obj;
    if (snapshot)
        return snapshot;
    if (obj.$)
        return toJS(obj.$);
    return enforceStringIdOnSnapshot((_c = copyWithJSON(toJS(obj))) !== null && _c !== void 0 ? _c : {});
};
